import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import lo from './locales/lo'
import th from './locales/th'

const LOCALE_KEY = 'site_locale'
const saved = localStorage.getItem(LOCALE_KEY)
const defaultLocale = ['zh', 'en', 'lo', 'th'].includes(saved) ? saved : 'zh'

const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'zh',
  messages: { zh, en, lo, th },
})

export function setLocale(locale) {
  if (!['zh', 'en', 'lo', 'th'].includes(locale)) return
  i18n.global.locale.value = locale
  localStorage.setItem(LOCALE_KEY, locale)
  const langMap = { zh: 'zh-CN', en: 'en', lo: 'lo', th: 'th' }
  document.documentElement.lang = langMap[locale] || locale
}

setLocale(defaultLocale)

export default i18n
